import { render, staticRenderFns } from "./invite-form.vue?vue&type=template&id=125067d2&scoped=true"
import script from "./invite-form.vue?vue&type=script&lang=js"
export * from "./invite-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125067d2",
  null
  
)

export default component.exports